const yesNoFilter = [
  {
    text: 'Yes',
    value: true,
  },
  {
    text: 'No',
    value: false,
  },
]

export default yesNoFilter
